import type { ReactNode } from 'react';

type Props = {
  doctorName?: string;
  children: ReactNode;
  /** Widen the card for the two-column date/time step. */
  wide?: boolean;
};

/**
 * Branded shell for standalone (ad landing) mode. Minimal, focused on the
 * single CTA — booking. Avoid distractions like nav menus or external links.
 *
 * Replace the logo placeholder with the real Alena mark once you have a
 * deployable asset.
 */
export function Landing({ doctorName, children, wide = false }: Props) {
  return (
    <div className="landing">
      <header className="landing-header">
        {/* TODO: replace with <img src="/logo.svg" alt="Clínica Alena" /> */}
        <div className="landing-logo">Clínica Alena</div>
      </header>

      <section className="landing-hero">
        <h1>Reservá tu cita en línea</h1>
        <p>
          {doctorName ? (
            <>
              Agendá con <strong>{doctorName}</strong> en menos de 2 minutos.
            </>
          ) : (
            'Agendá con nuestros especialistas en menos de 2 minutos.'
          )}
        </p>
      </section>

      <main className={`landing-widget${wide ? ' wide' : ''}`}>{children}</main>

      <footer className="landing-footer">
        <p>Atención profesional · Costa Rica</p>
      </footer>
    </div>
  );
}
